import { render, staticRenderFns } from "./EmployerMatchDollarLimitRadio.vue?vue&type=template&id=0fe74cd2&"
import script from "./EmployerMatchDollarLimitRadio.vue?vue&type=script&lang=js&"
export * from "./EmployerMatchDollarLimitRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports